const safetyTips = [
  {
    icon: 'ri-shield-star-line',
    title: 'Verify Seller Reviews',
    desc: 'Always check recent reviews and ratings before purchasing. Look for sellers with consistent positive feedback over time, not just a few good reviews.',
  },
  {
    icon: 'ri-image-add-line',
    title: 'Inspect QC Photos',
    desc: 'Request and carefully review QC photos before shipping. Compare them against product listings to ensure what you ordered matches what you will receive.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Compare Shipping Methods',
    desc: 'Different shipping lines have different costs, speeds, and reliability. Choose based on your budget and urgency, and always check estimated delivery times.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Start Small First',
    desc: 'When trying a new seller, place a small test order first. This reduces risk while you evaluate quality, communication, and shipping reliability.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Protect Your Information',
    desc: 'Never share personal payment details outside the platform. Use the built-in payment system and avoid direct transactions with unknown sellers.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Know Return Policies',
    desc: 'Understand return and refund policies before ordering. Some items cannot be returned, so read the fine print and ask questions beforehand.',
  },
];

export default function SafetySection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Shop With Confidence</p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
              Safety Center
            </h2>
            <p className="mt-4 text-sm text-foreground-500 max-w-xl mx-auto leading-relaxed">
              Always verify seller reviews, inspect QC photos, and compare shipping methods before purchasing. Our guides help reduce risks and improve buying decisions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {safetyTips.map((tip) => (
              <div key={tip.title} className="flex gap-4 p-5 rounded-lg bg-background-100">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className={`${tip.icon} text-lg`}></i>
                </span>
                <div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-1.5">{tip.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{tip.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 p-6 rounded-lg bg-accent-50 border border-accent-100/50 text-center">
            <p className="text-sm text-foreground-700 leading-relaxed">
              <strong className="text-accent-700">Safety Disclaimer:</strong> While our Pandabuy Spreadsheet provides verified seller information and buying guides, always exercise your own judgment when making purchases. We recommend reviewing seller feedback, inspecting QC photos carefully, and understanding platform policies before completing any transaction. Happy and safe shopping!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}